import { useQuery } from "@tanstack/react-query";
import { tenantKeys } from "~api/tenants.ts";
import { Ability } from "~auth/Ability.ts";
import { usePermitted } from "~auth/usePermitted.ts";
import { useIsDesktop } from "~components/shared/useIsDesktop/useIsDesktop.ts";
import { useCurrentTenant } from "~contexts/CurrentTenantContext/CurrentTenantContext.tsx";
import { PhotoDocumentationService } from "~generated";

const failedMobileUploadsKeys = {
  base: (tenantId: string) =>
    [
      ...tenantKeys.detail(tenantId),
      "photo_documentation",
      "failed_mobile_uploads",
      "v1",
    ] as const,
};

export function useFailedMobileUploads(): { count: number } {
  const isPermitted = usePermitted();
  const { id: tenantId } = useCurrentTenant();

  const isDesktop = useIsDesktop();

  const enabled =
    isDesktop && isPermitted([Ability.canCreatePhotoDocumentation]);

  const { data } = useQuery({
    queryKey: failedMobileUploadsKeys.base(tenantId),
    queryFn: () =>
      PhotoDocumentationService.getPhotoDocFailedMobileUploads(tenantId),
    enabled,
    staleTime: 30_000,
  });

  return { count: data?.count ?? 0 };
}
